import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Collapsible, DNABox, DNAButton, DNACard, DNAText, Icon, Iffy, luxColors, Popover, } from '@alucio/lux-ui';
import colors from '../../../theming/themes/alucio/colors';
const styles = StyleSheet.create({
    iconStyle: {
        color: luxColors.contentText.quaternary,
        height: 20,
        paddingLeft: 5,
        width: 20,
    },
    wrapper: {
        paddingHorizontal: 18,
        paddingVertical: 16,
        borderTopColor: colors['color-flat-300'],
        borderTopWidth: 1,
    },
});
const DNACollapsibleCard = ((props) => {
    const { collapsedDefault, headerTitle, popoverInfoText, children, customWrapperStyle, } = props;
    const [isCollapsed, setIsCollapsed] = useState(!!collapsedDefault);
    function toggleCollapse() {
        setIsCollapsed(open => !open);
    }
    return (<DNABox appearance="col" spacing="medium">
      <DNACard style={{ minHeight: 'fit-content' }} appearance="outline">
        
        <DNABox style={styles.wrapper} spacing="between" alignY="center">
          <DNABox spacing="small" alignY="center">
            <DNAButton status="subtle" appearance="ghostAlt" context="minimum" iconLeft={!isCollapsed ? 'chevron-down' : 'chevron-right'} onPress={toggleCollapse}/>
            <DNAText b1 bold>{headerTitle}</DNAText>
          </DNABox>
          <Iffy is={popoverInfoText}>
            <Popover>
              <Popover.Anchor>
                <Icon style={styles.iconStyle} name="help-circle-outline"/>
              </Popover.Anchor>
              <Popover.Content>
                <DNAText status="basic">{popoverInfoText}</DNAText>
              </Popover.Content>
            </Popover>
          </Iffy>
        </DNABox>
        <Collapsible collapsed={isCollapsed}>
          
          <DNABox appearance="col" spacing={isCollapsed ? undefined : 'medium'} style={[styles.wrapper, customWrapperStyle]}>
            {children}
          </DNABox>
        </Collapsible>
      </DNACard>
    </DNABox>);
});
export default DNACollapsibleCard;
//# sourceMappingURL=DNACollapsibleCard.js.map